import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import icon1 from "../../img/home/why-icon-1.svg";
import icon2 from "../../img/home/why-icon-2.svg";
import icon3 from "../../img/home/why-icon-3.svg";
import icon4 from "../../img/home/why-icon-4.svg";
import icon5 from "../../img/home/why-icon-5.svg";
import icon6 from "../../img/home/why-icon-6.svg";

const CARDS = [
  { icon: icon1, tk: "home.why.card1.title", dk: "home.why.card1.desc" },
  { icon: icon2, tk: "home.why.card2.title", dk: "home.why.card2.desc" },
  { icon: icon3, tk: "home.why.card3.title", dk: "home.why.card3.desc" },
  { icon: icon4, tk: "home.why.card4.title", dk: "home.why.card4.desc" },
  { icon: icon5, tk: "home.why.card5.title", dk: "home.why.card5.desc" },
  { icon: icon6, tk: "home.why.card6.title", dk: "home.why.card6.desc" },
];

const ChevronLeft = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden>
    <path d="M8.19092 0.494953L0.989907 7.69596L8.19092 14.897M0.989907 7.69596L15.3919 7.69596" stroke="#707070" strokeWidth="1.4" />
  </svg>
);

const ChevronRight = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden>
    <path d="M7.20117 14.8972L14.4023 7.69609L7.20117 0.494995M14.4023 7.69609H8.10744e-05" stroke="#707070" strokeWidth="1.4" />
  </svg>
);

function WhyChoose() {
  const { t } = useTranslation();
  const [activeIndex, setActiveIndex] = useState(0);
  const [direction, setDirection] = useState(1);

  const goTo = (index) => {
    setDirection(index > activeIndex ? 1 : -1);
    setActiveIndex(index);
  };

  const prev = () => {
    setDirection(-1);
    setActiveIndex((i) => Math.max(0, i - 1));
  };

  const next = () => {
    setDirection(1);
    setActiveIndex((i) => Math.min(CARDS.length - 1, i + 1));
  };

  return (
    <section className="mt">
      <div className="glcontainer flex flex-col gap-[60px]">

        {/* Header */}
        <div className="flex flex-col items-center gap-[24px]">
          <h2 className="font-46-28 xl:text-center">{t("home.why.title")}</h2>
          <p className="font-18-14 xl:text-center max-w-[768px]">{t("home.why.desc")}</p>
        </div>

        {/* Desktop grid (sm+) */}
        <div className="hidden sm:grid sm:grid-cols-2 xl:grid-cols-3 gap-[24px]">
          {CARDS.map((card, i) => (
            <div key={i} className="bg-[#fcefea] rounded-[20px] px-[24px] py-[40px] min-h-[260px] flex flex-col">
              <div className="flex items-center justify-center w-[48px] h-[48px] rounded-[40px] bg-[#ee5414] shrink-0">
                <img src={card.icon} alt="" className="max-w-[22px] max-h-[20px] object-contain" />
              </div>
              <p className="font-['Montserrat'] font-extrabold text-[20px] text-[#020202] leading-normal mt-[8px] pt-[8px]">
                {t(card.tk)}
              </p>
              <p className="font-['Inter'] font-normal text-[16px] text-[#717171] leading-[24px] mt-[4px]">
                {t(card.dk)}
              </p>
            </div>
          ))}
        </div>

        {/* Mobile carousel (< sm) */}
        <div className="sm:hidden flex flex-col gap-[20px]">

          {/* Active card */}
          <div
            key={activeIndex}
            className={`swiper-card-enter ${direction > 0 ? "swiper-card-next" : "swiper-card-prev"} bg-[#fcefea] rounded-[20px] px-[24px] py-[40px] min-h-[250px] flex flex-col justify-start`}
          >
            <div className="flex items-center justify-center w-[48px] h-[48px] rounded-[40px] bg-[#ee5414] shrink-0">
              <img src={CARDS[activeIndex].icon} alt="" className="max-w-[22px] max-h-[20px] object-contain" />
            </div>
            <p className="font-['Montserrat'] font-semibold text-[20px] text-[#020202] leading-[32px] mt-[8px]">
              {t(CARDS[activeIndex].tk)}
            </p>
            <p className="font-['Inter'] font-normal text-[16px] text-[#717171] leading-[24px] mt-[4px]">
              {t(CARDS[activeIndex].dk)}
            </p>
          </div>

          {/* Navigation bar */}
          <div className="flex items-center justify-between bg-[#f7f7f7] rounded-[20px] h-[28px] px-[18px] py-[4px]">
            <button
              onClick={prev}
              disabled={activeIndex === 0}
              className="flex items-center justify-center w-[28px] h-[20px] cursor-my disabled:opacity-30"
              aria-label="Previous"
            >
              <ChevronLeft />
            </button>

            <div className="flex items-center gap-[8px]">
              {CARDS.map((_, i) => (
                <button
                  key={i}
                  onClick={() => goTo(i)}
                  className={`w-[8px] h-[8px] rounded-full cursor-my transition-colors duration-200 ${
                    i === activeIndex ? "bg-[#ee5414]" : "bg-[#d9d9d9]"
                  }`}
                  aria-label={`Go to slide ${i + 1}`}
                />
              ))}
            </div>

            <button
              onClick={next}
              disabled={activeIndex === CARDS.length - 1}
              className="flex items-center justify-center w-[28px] h-[20px] cursor-my disabled:opacity-30"
              aria-label="Next"
            >
              <ChevronRight />
            </button>
          </div>

        </div>

      </div>
    </section>
  );
}

export default WhyChoose;
